package com.nonopn.skywatcher.app.utils

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.CoroutineStart
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.cancel
import kotlinx.coroutines.channels.Channel
import kotlinx.coroutines.launch
import kotlinx.coroutines.suspendCancellableCoroutine
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.EmptyCoroutineContext
import kotlin.coroutines.resume
import kotlin.coroutines.resumeWithException

class Queue(private val scope: CoroutineScope) {
    private val internalQueue = Channel<Job>(Channel.UNLIMITED)

    init {
        scope.launch(Dispatchers.Default) {
            for (job in internalQueue) {
                try {
                    job.join()
                } catch (ignored: Throwable) {
                    // ignored
                }
            }
        }
    }

    suspend fun <T> enqueue(
        context: CoroutineContext = EmptyCoroutineContext,
        block: suspend CoroutineScope.() -> T
    ) = suspendCancellableCoroutine { continuation ->
        @Suppress("TooGenericExceptionCaught")
        post(context) {
            try {
                val execution = block()

                continuation.resume(execution)
            } catch (err: Throwable) {
                continuation.resumeWithException(err)
            }
        }
    }

    fun post(
        context: CoroutineContext = EmptyCoroutineContext,
        block: suspend CoroutineScope.() -> Unit
    ) = internalQueue.trySend(
        scope.launch(
            context,
            CoroutineStart.LAZY,
            block
        )
    )

    fun cancel() {
        internalQueue.cancel()
        scope.cancel()
    }
}
